import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CleanSessionManagement from './CleanSessionManagement';
import CalendarView from './CalendarView';
import { Calendar, List } from 'lucide-react';

function Sessions() {
  const { t, i18n } = useTranslation();
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'calendar'

  return (
    <div className="flex-1 overflow-y-auto bg-neutral-50 p-4 sm:p-6 lg:p-8" dir={i18n.language === 'ar' ? 'rtl' : 'ltr'}>
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">{t('sessions.title')}</h1>
        <p className="text-gray-600">
          {t('sessions.subtitle')}
        </p>
      </div>

      {/* View Toggle */}
      <div className="flex items-center justify-between mb-8">
        <div className="flex items-center space-x-2 bg-white rounded-lg p-1 shadow-sm border border-gray-200">
          <button
            onClick={() => setViewMode('list')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
              viewMode === 'list' 
                ? 'bg-white text-primary-600 shadow-sm ring-1 ring-black/5' 
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
            }`}
          >
            <List className="w-4 h-4" />
            <span>{t('sessions.listView')}</span>
          </button>
          <button
            onClick={() => setViewMode('calendar')}
            className={`flex items-center space-x-2 px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 ${
              viewMode === 'calendar' 
                ? 'bg-white text-primary-600 shadow-sm ring-1 ring-black/5' 
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-50'
            }`}
          >
            <Calendar className="w-4 h-4" />
            <span>{t('sessions.calendarView')}</span>
          </button>
        </div>
      </div>
      
      {/* Content */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden">
        {viewMode === 'list' && <CleanSessionManagement />}
        {viewMode === 'calendar' && <CalendarView />}
      </div>
    </div>
  );
}

export default Sessions;